import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBIazYmnLknGDZrPzn6hYVnrdaJLFw47-c",
  authDomain: "rsabharat-homegenie.firebaseapp.com",
  projectId: "rsabharat-homegenie",
  storageBucket: "rsabharat-homegenie.firebasestorage.app",
  messagingSenderId: "699943776432",
  appId: "1:699943776432:web:3f19c64e10db4bfc340b75",
  measurementId: "G-B2HFP7GY2C"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
const db = getFirestore(app);

export { app, auth, db};
